import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { IGetPorterViewModel, IPorterBudget, IGetPorterBudgetItemPrice, IGetPorterItemListViewModel, ProductViewModel, PorterViewModel, GetPorterBudgetItemPricesCommandArguments } from "Api/CoreApi";
import ApiProvider from 'Api/ApiProvider';
import porterBuilder from 'Store/porterbuilder/porterbuilder';


@Component({})
export default class PorterItemListComponent extends Vue {

    @Prop()
    porterId: string;

    @Prop()
    languageId: string;

    @Prop()
    defaultUnits: { [productNumber: string]: string };

    public units: { [productNumber: string]: string } = {};

    porter: IGetPorterViewModel = { porter: new PorterViewModel };
    porterItems: IGetPorterItemListViewModel = {};
    porterBudget: IPorterBudget = {};
    porterBudgetPrices: IGetPorterBudgetItemPrice[] = [];
    loading: boolean = true;
    initialized : boolean = true;
    hasBudget: boolean = false;
    line: {unit: string}[] = [];


    getComment(number: string): string {
        if (this.porterItems && this.porterItems.porterItems) {
            for (let item of this.porterItems.porterItems) {
                if (item.porterItem.itemNo === number) {
                    // Comment first, as this means that they have not yet managed to convert this to adjustment item in NAV
                    if (item.porterItem.comment)
                        return item.porterItem.comment;

                    return item.porterItem.adjustmentItem;
                }
            }

        }
        return '';
    }

    getInUse(number: string): number {
        if (this.porterItems && this.porterItems.porterItems) {
            for (let item of this.porterItems.porterItems) {
                if (item.porterItem.itemNo === number) {
                    return item.porterItem.quantityInUse;
                }
            }

        }
        return 0;
    }

    public get employeeCode() {
        if (this.porter && this.porter.fields && this.porter.fields.map(p => p.key).includes("EmployeeCode")) {
            return this.porter.porter.genericFields.EmployeeCode; 
        }
        return ""; 
    }

    async mounted() {
        this.units = this.defaultUnits;
        const client = ApiProvider.getApiClient();
        this.porter = await client.getPorterById(this.porterId);

        this.hasBudget = this.porter.porter.hasBudget;

        this.porterItems = await client.getPorterItems(this.languageId, this.porterId);

        var products:ProductViewModel[] = [];
        for (let item of this.porterItems.porterItems) {
            item.product.basicMetrics["defaultUnit"] = this.units[item.product.itemNumber];
            products.push(item.product);
        }

        if (this.hasBudget) {
            var bugdetItemPricesArgument = new GetPorterBudgetItemPricesCommandArguments({
                porterUserName: this.porter.porter.contactNo,
                products: products
            });

            var budgetItemPricesReponse = await client.getPorterBudgetItemPrices(bugdetItemPricesArgument);

            if (budgetItemPricesReponse && budgetItemPricesReponse.items) {
                this.porterBudgetPrices.push(...budgetItemPricesReponse.items);
            }
        }
        
        var resonse = await client.getPorterBudget(this.porter.porter.contactNo);
        var budget = resonse.budgets[0];
        if (budget != null && budget != undefined) {
            this.porterBudget = budget;
        }

        this.loading = false;
    }

    getBudgetItemPrice(itemNo: string) {
        var budgetItemPrice = this.porterBudgetPrices.find(x => x.no == itemNo);
        if (!budgetItemPrice) return "";
        return budgetItemPrice;
    }

    allowBuyItem(itemNo:string, oldModelSelection : boolean){
        let item = this.findPorterItem(itemNo);
        if(item && item.porterItem && item.porterItem.isOldModelSales){
            return false;
        }
       return !oldModelSelection;
    }

    isItemOldModelPorter(itemNo : string){
        if (this.porterItems && this.porterItems.porterItems){
            return this.porterItems.porterItems.find(x=>x.porterItem.itemNo == itemNo).porterItem.isOldModelSales;
        }
        return null;
    }
    findPorterItem(itemNo : string){
        if (this.porterItems.porterItems){
            return this.porterItems.porterItems.find(x=>x.porterItem.itemNo == itemNo);
        }
        return null;
    }

    goToBuilder(url: string) {
        porterBuilder.dispatchSetPorterId(this.porter.porter.id).then(() => window.location.href = url + "?porterNo=" + this.porter.porter.contactNo);
    }

}

Vue.component('porter-item-list', PorterItemListComponent);
